import { styled } from '@mui/material/styles';
import { Stack } from 'components/ui';

export const AuthPageStackRoot = styled(Stack)(({ theme }) => ({
  width: '100%',
  '& > :not(style) + :not(style)': {
    marginTop: theme.spacing(3),
  },
  '& > [data-auth-header-root="true"] + :not(style)': {
    marginTop: 0,
  },
}));
